import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=73be0e05&"
import script from "./CalendarEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/knowledge.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/calendar.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports